import React from 'react';
import { PageContainer } from 'components/shared/Page/PageContainer';
import { CustomersCard } from '../components';

export const CustomersPage = () => {
  return (
    <PageContainer>
      <CustomersCard />
    </PageContainer>
  );
};
